const patches = {
    'v1': ['1.x', '1.0', '1.1', '1.2', '1.3', '1.4', '1.5', '1.6', '1.7', '1.8', '1.9', '1.10', '1.11', '1.12'],
    'v2': ['2.x', '2.0', '2.1', '2.2', '2.3', '2.4'],
    'v3': ['3.x', '3.0', '3.1', '3.2', '3.3'],
    'v4': ['4.x', '4.0', '4.1', '4.2', '4.3'],
    'v5': ['5.x', '5.0', '5.1', '5.2', '5.3', '5.4'],
    'v6': ['6.x', '6.0', '6.1', '6.2'],
    'v7': ['7.x', '7.0', '7.1', '7.1.5', '7.2', '7.2.5', '7.3', '7.3.5'],
    'v8': ['8.x', '8.0', '8.1', '8.1.5', '8.2', '8.2.5', '8.3'],
    'v9': ['9.x', '9.0', '9.0.5', '9.1', '9.1.5', '9.2', '9.2.5', '9.2.7'],
    'v10': ['10.x', '10.0', '10.0.5', '10.0.7', '10.1', '10.1.5', '10.1.7', '10.2', '10.2.5', '10.2.6', '10.2.7'],
    'v11': ['11.x', '11.0', '11.0.5', '11.0.7', '11.1', '11.1.5', '11.1.7', '11.2', '11.2.5', '11.2.7']
};
patches.all = [].concat(...Object.values(patches));

const expansions = {
    'v1': 'Classic',
    'v2': 'TBC',
    'v3': 'WotLK',
    'v4': 'Cataclysm',
    'v5': 'MoP',
    'v6': 'WoD',
    'v7': 'Legion',
    'v8': 'BfA',
    'v9': 'Shadowlands',
    'v10': 'Dragonflight',
    'v11': 'TWW'
};

const majorVersions = {};
Object.keys(expansions).forEach(v => patches[v].forEach(p => majorVersions[p] = v));



const races = [ { key: '', value: 'Neutral' }, { value: 'Blood Elf', key: 10, faction: 1, color: '#b30000' }, { value: 'Dark Iron Dwarf', key: 34, faction: 0, color: '#0078ff' }, { value: 'Dracthyr (A)', key: 52, faction: 0, color: '#0078ff' }, { value: 'Dracthyr (H)', key: 70, faction: 1, color: '#b30000' }, { value: 'Draenei', key: 11, faction: 0, color: '#0078ff' }, { value: 'Dwarf', key: 3, faction: 0, color: '#0078ff' }, { value: 'Earthen (A)', key: 85, faction: 0, color: '#0078ff' }, { value: 'Earthen (H)', key: 84, faction: 1, color: '#b30000' }, { value: 'Gnome', key: 7, faction: 0, color: '#0078ff' }, { value: 'Goblin', key: 9, faction: 1, color: '#b30000' }, { value: 'Highmountain Tauren', key: 28, faction: 1, color: '#b30000' }, { value: 'Human', key: 1, faction: 0, color: '#0078ff' }, { value: 'Kul Tiran', key: 32, faction: 0, color: '#0078ff' }, { value: 'Lightforged Draenei', key: 30, faction: 0, color: '#0078ff' }, { value: "Mag'har Orc", key: 36, faction: 1, color: '#b30000' }, { value: 'Mechagnome', key: 37, faction: 0, color: '#0078ff' }, { value: 'Night Elf', key: 4, faction: 0, color: '#0078ff' }, { value: 'Nightborne', key: 27, faction: 1, color: '#b30000' }, { value: 'Orc', key: 2, faction: 1, color: '#b30000' }, { value: 'Pandaren (A)', key: 25, faction: 0, color: '#0078ff' }, { value: 'Pandaren (H)', key: 26, faction: 1, color: '#b30000' }, { value: 'Pandaren (N)', key: 24 }, { value: 'Tauren', key: 6, faction: 1, color: '#b30000' }, { value: 'Troll', key: 8, faction: 1, color: '#b30000' }, { value: 'Undead', key: 5, faction: 1, color: '#b30000' }, { value: 'Void Elf', key: 29, faction: 0, color: '#0078ff' }, { value: 'Vulpera', key: 35, faction: 1, color: '#b30000' }, { value: 'Worgen', key: 22, faction: 0, color: '#0078ff' }, { value: 'Zandalari Troll', key: 31, faction: 1, color: '#b30000' } ];
const allianceRaces = new Set(races.filter(r => r.faction === 0).map(r => r.key));
const hordeRaces = new Set(races.filter(r => r.faction === 1).map(r => r.key));



const constants = { races, allianceRaces, hordeRaces, patches, expansions, majorVersions };
export default constants;